import { Sun, Shield, Star } from "lucide-react";

const features = [
  {
    icon: Sun,
    title: "Gulf Front Living",
    description: "Every property is steps from the white sand beaches of the Emerald Coast.",
  },
  {
    icon: Shield,
    title: "Trusted & Verified",
    description: "Professionally managed homes with 24/7 support and secure booking.",
  },
  {
    icon: Star,
    title: "Save vs Airbnb & Vrbo",
    description: "Book direct and skip the platform service fees. Same homes, better rates.",
  },
];

const FeaturesSection = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-sand-light">
      <div className="container mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-xs font-body uppercase tracking-[0.2em] text-accent font-semibold mb-3">
            The Amplify Difference
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground tracking-tight leading-[1.05] mb-4">
            Why Amplify Vacations
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {features.map((feature) => (
            <div key={feature.title} className="text-center px-4">
              <div className="w-14 h-14 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-5">
                <feature.icon className="h-6 w-6 text-accent" />
              </div>
              <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="font-body text-sm text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
